import React, { useEffect, useState } from "react";
import { get, deleteRequest } from "api";
import DataTable from "react-data-table-component";
import CircularProgress from "@mui/material/CircularProgress";
import { useHistory } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
interface Content {
  _id: string;
  slug: string;
  title: string;
  description: string;
  type: string;
  category: string;
}

const ListContent: React.FC = () => {
  const history = useHistory();

  const [contents, setContents] = useState<Content[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    get("/contents")
      .then((response) => {
        setContents(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching content data:", error);
        setLoading(false);
      });
  }, []);

  const handleEditClick = (slug: string) => {
    history.push(`/dashboard/edit-content/${slug}`);
  };

  const handleDeleteClick = (id: string) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this content?"
    );
    if (confirmDelete) {
      deleteRequest(`/contents/${id}`)
        .then(() => {
          return get("/contents");
        })
        .then((response) => {
          setContents(response.data);
        })
        .catch((error) => {
          console.error("Error deleting content:", error);
        });
    }
  };

  const handleRowClicked = (row: Content) => {
    history.push(`/dashboard/edit-content/${row.slug}`);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyword = e.target.value.toLowerCase();
    setSearchQuery(keyword);
  };

  const columns = [
    {
      name: "Title",
      selector: (row: Content) => row.title,
      sortable: true,
      grow: 2,
    },
    {
      name: "Description",
      selector: (row: Content) => row.description,
      sortable: true,
    },
    {
      name: "Category",
      selector: (row: Content) => row.category,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row: Content) => row.type,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row: Content) => (
        <div className="btn-group" role="group" aria-label="Basic example">
          <button
            type="button"
            onClick={() => handleEditClick(row.slug)}
            className="btn btn-warning me-2"
          >
            Edit
          </button>

          <button
            type="button"
            onClick={() => handleDeleteClick(row._id)}
            className="btn btn-danger"
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        minWidth: "100%",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    search: {
      style: {
        position: "relative",
        width: "100%",
      },
    },
    searchInput: {
      style: {
        width: "100%",
      },
    },
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div className="d-flex align-items-center w-100">
        <input
          type="text"
          placeholder="Search content..."
          onChange={handleSearch}
          className="form-control me-2"
          value={searchQuery}
        />
        <div className="cursor-pointer" onClick={() => setSearchQuery("")}>
          <RefreshIcon />
        </div>
      </div>
    );
  }, [searchQuery]);

  const filteredContents = contents.filter(
    (content) =>
      content.title.toLowerCase().includes(searchQuery) ||
      content.description.toLowerCase().includes(searchQuery) ||
      content.category.toLowerCase().includes(searchQuery) ||
      content.type.toLowerCase().includes(searchQuery)
  );

  return (
    <div className="">
      <div className="w-100">
        <h3>Content List</h3>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress size={30} />
          </div>
        ) : (
          <DataTable
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            data={filteredContents}
            columns={columns}
            pagination
            paginationPerPage={10}
            customStyles={customStyles}
            onRowClicked={handleRowClicked}
            highlightOnHover
            pointerOnHover
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ListContent;
